import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  StyledCard,
  VendorCardLabel,
} from "../../vendorRegistration/components/StepMain";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box, CardContent, Grid, TextField } from "@mui/material";
import { Super } from "../../vendorRegistration/components/steps/cardTrial";
import { history } from "../../../app/history";
import { addBusinessUnit } from "../redux/businessUnitSlice";

function BusinessUnitContent() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleSave = (data) => {
    setLoading(true);
    const payload = {
      businessUnitName: data.name,
      businessUnitDesc: data.description,
    };

    dispatch(addBusinessUnit(payload)).then((response) => {
      if (response?.payload?.success) {
        setLoading(false);
        history.push("/app/business-unit");
      } else {
        setLoading(false);
      }
    });
  };

  return (
    <>
      <form onSubmit={handleSubmit(handleSave)}>
        <StyledCard>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item md={12}>
                <VendorCardLabel>
                  Name<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  placeholder="Enter Name"
                  size="small"
                  variant="standard"
                  style={{ width: "100%", paddingTop: "3px" }}
                  name="name"
                  {...register("name", {
                    required: "Please enter name",
                  })}
                  error={Boolean(errors?.name)}
                  helperText={errors?.name?.message}
                />
              </Grid>
              <Grid item md={12}>
                <VendorCardLabel>
                  Description<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  placeholder="Enter Description"
                  size="small"
                  variant="standard"
                  style={{ width: "100%", paddingTop: "3px" }}
                  name="description"
                  {...register("description", {
                    required: "Please enter description",
                  })}
                  error={Boolean(errors?.description)}
                  helperText={errors?.description?.message}
                />
              </Grid>
            </Grid>
          </CardContent>
        </StyledCard>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            pt: 2,
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <LoadingButton
            sx={{
              textTransform: "none",
              background: "#4059e5",
              width: "200px",
              height: "40px",
            }}
            color="primary"
            variant="contained"
            type="submit"
            loading={loading}
            loadingPosition="start"
          >
            Create
          </LoadingButton>
        </Box>
      </form>
    </>
  );
}

export default BusinessUnitContent;
